import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  IconButton,
  ButtonGroup,
  Button,
  ButtonProps,
  IconButtonProps,
} from "@chakra-ui/react";
import {
  ColumnIcon,
  EditIcon,
  EllipsisIcon,
  EMLConfigurationIcon,
  EventsModuleConfigurationIcon,
  FormIcon,
  GearIcon,
  GeoFenceConfigurationIcon,
  IntegrationIcon,
  LandingPageConfigurationIcon,
  MemberIcon,
  MembershipRenewalIcon,
  PassConfigurationIcon,
  PushNotificationIcon,
  VenueIcon,
} from "../../styles/icons";
import { BusinessMenuItem } from "./BusinessMenuItem";

interface BusinessMenuProps {
  businessId: string;
  children?: React.ReactNode;
  onlyEllipsis?: boolean;
  iconBtnProps?: IconButtonProps;
}

export const BusinessMenu = ({
  businessId,
  children,
  onlyEllipsis,
  iconBtnProps,
  ...props
}: BusinessMenuProps & ButtonProps) => (
  <ButtonGroup isAttached>
    {!onlyEllipsis && (
      <Button
        leftIcon={<EditIcon />}
        colorScheme="cherryButton"
        borderRight="1px"
        {...props}
      >
        {children ?? "Edit"}
      </Button>
    )}

    <Menu size="sm">
      <MenuButton
        as={IconButton}
        colorScheme="cherryButton"
        aria-label="Options"
        title="Options"
        icon={<EllipsisIcon />}
        {...iconBtnProps}
      />

      <MenuList>
        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/venues`}
          icon={<VenueIcon />}
        >
          Venues
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/integrations`}
          icon={<IntegrationIcon />}
        >
          Integrations
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/registration-form-configurations`}
          icon={<FormIcon />}
        >
          Digital Membership Registration Forms
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/redemptions`}
          icon={<GearIcon />}
        >
          Digital Membership Redemption Forms
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/membership-renewals`}
          icon={<MembershipRenewalIcon />}
        >
          Membership Renewal Forms
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/extended-fields`}
          icon={<ColumnIcon />}
        >
          Extended Fields
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/eml-configuration`}
          icon={<EMLConfigurationIcon />}
        >
          EML Configuration
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/pass-configurations`}
          icon={<PassConfigurationIcon />}
        >
          Pass Configurations
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/landing-page-configurations`}
          icon={<LandingPageConfigurationIcon />}
        >
          Landing Page Configurations
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/member-self-service-configurations`}
          icon={<MemberIcon />}
        >
          Member Self-Service Configurations
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/events-module-configuration`}
          icon={<EventsModuleConfigurationIcon />}
        >
          Events Module Configuration
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/push-notifications-configuration`}
          icon={<PushNotificationIcon />}
        >
          Push Notification Configuration
        </BusinessMenuItem>

        <BusinessMenuItem
          path={`/admin/businesses/${businessId}/geo-fence-configuration`}
          icon={<GeoFenceConfigurationIcon />}
        >
          Geo-Fence Configuration
        </BusinessMenuItem>
      </MenuList>
    </Menu>
  </ButtonGroup>
);
